/**
 * Stitch Studio, the full embroidery editor. A separate app on its own
 * subdomain (the embroidery-desktop repo), so every way into it from here is
 * a plain link off the site: it shares no storage with this origin. A link
 * can still hand it the design on screen, as studioImportUrl's ?import=,
 * which Studio fetches from /assets/media (allowed by the API's CORS origins)
 * and adds to its document as stitches.
 *
 * Not behind a flag: it's the editor now, and /editor redirects to it.
 */

export const STUDIO_URL = "https://studio.embroiderytext.com/";

/**
 * A Studio link that opens with this design already in it. `fileUrl` must be
 * absolute (Studio only accepts this site's /assets/media URLs); `name` names
 * the document there, the URL's own file name being a content hash.
 */
export function studioImportUrl(fileUrl: string, name: string): string {
  const params = new URLSearchParams({ import: fileUrl, name });
  return `${STUDIO_URL}?${params}`;
}

// Where a click on a Studio link came from, for studio_link_clicked.
export type StudioSource =
  | "nav"
  | "home_hero"
  | "home_card"
  | "create_link"
  | "create_promo"
  | "convert"
  | "preview"
  | "studio_page"
  | "studio_page_template"
  | "studio_page_footer";
